import React, {PureComponent} from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import padding from "@irati/ui/src/global/padding"
import tracking from "@irati-tracking/wallet/tenantWallet"

interface Props extends InjectIntl {
  availableBalance: number
}

interface ButtonProps {
  marginTop?: boolean
}

const StyledButton = styled(ButtonRouterLink)<ButtonProps>`
  padding: ${padding.tiny};
  width: 100%;
  ${(props) => (props.marginTop ? `margin-top: ${padding.small}` : "")};
`

class TenantWalletTransactions extends PureComponent<Props> {
  render() {
    const {availableBalance} = this.props
    return (
      <>
        <StyledButton onClick={tracking.clickTopUp} to="/tenant/top-up">
          <FormattedMessage id="wallet.tenant.topUp.button" />
        </StyledButton>
        {availableBalance > 0 && (
          <StyledButton onClick={tracking.clickTransferCredit} primary marginTop to="/tenant/transfer">
            <FormattedMessage id="wallet.tenant.topUp.transfer" />
          </StyledButton>
        )}
        <StyledButton onClick={tracking.clickRefund} marginTop to="/tenant/refund">
          <FormattedMessage id="wallet.tenant.topUp.refund" />
        </StyledButton>
      </>
    )
  }
}

export default injectIntl(TenantWalletTransactions)
